import React, { useState, useEffect, useMemo, useRef, useCallback, Fragment } from 'react'
import { Card, Row, Col, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { axiosApi } from '../Basicos/axiosInstances';
import { connect } from 'react-redux';
import { NewLoader, TableWithVirtualizedRow } from '../Basicos';
import * as actionsRedux from './../Store/Actions/index';
import ModalAgruparAlunos from '../Basicos/Modal/ModalAgruparAlunos';
import ModalPeriodoCurso from '../Modal/ModalPeriodoCurso';
import ModalAlertGrupos from '../Modal/ModalAlertGrupos';
import ModalAtualizarAula from '../Modal/ModalAtualizarAula';

function AssociadorDeGruposProfessor({
    ativar,
    curso,
    setCursoId,
    periodoLetivo,
    setPeriodoLetivoId,
    subFuncionalidade: {
        url
    }
}) {
    const [semestres, setSemestres] = useState([]);

    const [semestreId, setSemestreId] = useState();

    const [semetreDescricao, setSemetreDescricao] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [periodosLetivos, setPeriodosLetivos] = useState([]);

    const [cursos, setCursos] = useState([]);

    const [GruposAssociados, setGruposAssociados] = useState();

    const [professores, setProfessores] = useState();

    const [professoresIds, setProfessoresIds] = useState([])

    const [grupos, setGrupos] = useState();

    const [grupos2, setGrupos2] = useState([]);
    const [professoresTutoria, setProfessoresTutoria] = useState([]);

    const [grupos3, setGrupos3] = useState([]);

    const [locais, setLocais] = useState([]);

    //modais
    const [modal, setModal] = useState(false);
    const [modalAgrupar, setModalAgrupar] = useState(false); // Remover Se Nao Quebrar
    const [modalAdicao, setModalAdicao] = useState(false);

    // Registra, por professor, quais campos foram de fato alterados nesta sessão de edição.
    // Usado para que o backend só sincronize horario_aula do que realmente mudou.
    const [alteracoes, setAlteracoes] = useState({});

    const semestresDoCursoSelecionado = () => semestres.filter(semestre => semestre.curso_id === curso);

    const cursoSelecionado = () => cursos.find(c => c.id === curso);

    const periodoLetivoSelecionado = () => periodosLetivos.find(pL => pL.id === periodoLetivo);
    const toggleModal = () => setModal(!modal);

    const gerar = (semestre_id) => {
        setIsLoading(true);
        axiosApi({
            method: 'get',
            url,
            params: {
                semestre_id,
                periodo_letivo_id: periodoLetivo,
            }
        }).then(resp => {
            setProfessores(resp.data.professores);
            setSemetreDescricao(resp.data.semestre)
            setGrupos(resp.data.grupo)
            setGrupos2(resp.data.grupo2)
            setProfessoresTutoria(resp.data.professoresTutoria)
            setGrupos3(resp.data.grupo3)
            setLocais(resp.data.locais)
            setAlteracoes({})
            setModalAdicao(true)
        }).catch(error => {
            if (error.response && error.response.data.erro)
                ativar(error.response.status, error.response.data.erro);
        }).finally(() => {
            setIsLoading(false);
        });
    }
    //Requisição inicial 
    useEffect(() => {
        axiosApi.get(url).then(resp => {
            setSemestres(resp.data.semestre);
            setPeriodosLetivos(resp.data.periodo);
            setGruposAssociados(resp.data.GruposAssociados);
            setCursos(resp.data.cursos);
            setProfessores(resp.data.professores);
        }).catch(error => {
            if (error.response.status === 403) {
                ativar(400, error?.response?.data?.mensagem);
            }
        });
    }, [url]);

    const SemestreItem = ({ semestre }) => {
        return (
            <Col className="mt-5">
                <Card className="d-flex py-5 ofertaPeriodo__card">
                    <span className="font-weight-bold azul-principal mx-auto mb-3 ofertaPeriodo__card--titulo">
                        {semestre.descricao}
                    </span>
                    <Button
                        className="font-weight-bold mx-auto"
                        onClick={() => gerar(semestre.id, professores)}
                    >
                        Visualizar
                    </Button>
                </Card>
            </Col>
        );
    }

    const CardComSemestres = () => {
        return (
            <Card className="mt-3 px-5 pb-5">
                <Row xs="1" sm="2" md="3" lg="4">
                    {
                        semestresDoCursoSelecionado().map(semestre => <SemestreItem semestre={semestre} key={semestre.id} />)
                    }
                </Row>
            </Card>
        );
    }

    const Titulo = () => {
        return (
            <h1 className="m-0 font-weight-bold label-nome-pagina">
                {periodoLetivoSelecionado()?.descricao} - {cursoSelecionado()?.nome}
                <Button onClick={toggleModal} className="float-right">
                    Editar
                </Button>
            </h1>
        );
    }
    return (
        <NewLoader isActive={isLoading} overlay >
            {
                (periodosLetivos && cursos && GruposAssociados && periodoLetivo && curso) &&
                <Fragment>
                    <Titulo />
                    <CardComSemestres />
                </Fragment>

            }
            {
                (periodosLetivos && cursos) &&
                <ModalPeriodoCurso
                    isOpen={modal}
                    setIsOpen={setModal}
                    cursos={cursos}
                    periodosLetivos={periodosLetivos}
                    cursoId={curso}
                    setCursoId={setCursoId}
                    periodoLetivoId={periodoLetivo}
                    setPeriodoLetivoId={setPeriodoLetivoId}
                />

            }
            {
                <ModalAdição
                    ativar={ativar}
                    grupos={grupos}
                    grupos2={grupos2}
                    professoresTutoria={professoresTutoria}
                    grupos3={grupos3}
                    locais={locais}
                    professores={professores}
                    setProfessores={setProfessores}
                    alteracoes={alteracoes}
                    setAlteracoes={setAlteracoes}
                    modalAdicao={modalAdicao}
                    setModalAdicao={setModalAdicao}
                    semestre={semetreDescricao}
                    professoresIds={professoresIds}
                    setProfessoresIds={setProfessoresIds}
                    modalAgrupar={modalAgrupar}
                    setModalAgrupar={setModalAgrupar}
                    cursoId={curso}
                    semestreId={semestreId}
                    setSemestreId={setSemestreId}
                    periodoLetivo={periodoLetivo}
                    setIsLoading={setIsLoading}
                    setModal={setModal}
                />
            }
        </NewLoader>
    );
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        ativarCofirmacao: (obj) => dispatch(actionsRedux.ativarModalConfirm(obj)),
        adicionarOnClick: (objeto) => dispatch(actionsRedux.adicionarSubFuncionalidade(ownProps.funcionalidade, ownProps.indiceSubFuncionalidade, objeto)),
        setCursoId: (tipo, acao) => dispatch(actionsRedux.setCurso(tipo, acao)),
        setPeriodoLetivoId: (tipo, acao) => dispatch(actionsRedux.setPeriodoLetivo(tipo, acao))
    }
}

const mapStateToProps = (state) => {
    return {
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        curso: state.auth.cursoId,
        periodoLetivo: state.auth.periodoLetivoId
    }
}

function ModalAdição({
    ativar,
    professores,
    grupos,
    grupos2,
    grupos3,
    professoresTutoria,
    locais,
    semestre,
    setProfessores,
    alteracoes,
    setAlteracoes,
    professoresIds,
    setProfessoresIds,
    modalAdicao,
    setModalAdicao,
    modalAgrupar,
    setModalAgrupar,
    cursoId,
    semestreId,
    setSemestreId,
    periodoLetivo,
    setIsLoading,
    setModal
}) {

    // Uma cópia mutável de `grupos` por "pool" (ex: 'ace', 'cha', 'mfc'), criada sob demanda
    // e recriada a cada render de ModalAdição — usada por gruposOptionsPara para ir descartando,
    // por pool, os grupos já atribuídos a algum professor. CHA e CHA2 compartilham a pool 'cha'
    // de propósito (um grupo não pode ser ao mesmo tempo CHA e CHA2 de outro professor).
    const poolsDisponiveis = {};
    const [modalCritica, setModalCritica] = useState(false);
    const [modalAtualizar, setModalAtualizar] = useState(false);
    const [textoModalCritica, setTextoModalCritica] = useState(false);
    const [aceFaltando, setAceFaltando] = useState();
    const [chaFaltando, setChaFaltando] = useState();
    const [tutFaltando, setTutFaltando] = useState();

    const setFiltro = (e) => {
        console.log(e)
    }

    // Substitui gruposOptionsAce/gruposOptionsCha/gruposOptionsCha2 (que eram cópias quase
    // idênticas, uma por atividade). `poolKey` isola a pool mutável de grupos "ainda disponíveis"
    // (CHA e CHA2 compartilham a mesma pool de propósito); `campoProfessor` é o campo do professor
    // a inspecionar (ex: 'grupo_ace', 'grupo_cha', 'grupo_cha2', 'grupo_mfc').
    const gruposOptionsPara = (poolKey, campoProfessor) => {
        if (!poolsDisponiveis[poolKey]) poolsDisponiveis[poolKey] = grupos != undefined ? grupos.slice() : [];
        const pool = poolsDisponiveis[poolKey];

        var contemSubgrupo = false;
        var contemGrupo = false;
        professores.forEach(professor => {
            professor[campoProfessor].forEach(grupoId => {
                const grupoIndex = pool.findIndex(element => element.id === grupoId);
                if (grupoIndex !== -1 && pool[grupoIndex].id !== pool[grupoIndex].grupo_principal_id) {
                    const grupoPrincipalIndex = pool.findIndex(element => element.id === pool[grupoIndex].grupo_principal_id);
                    if (grupoPrincipalIndex !== -1) {
                        pool.splice(grupoPrincipalIndex, 1);
                    }
                    contemSubgrupo = true;
                } else if (grupoIndex !== -1 && pool[grupoIndex].id == pool[grupoIndex].grupo_principal_id) {
                    contemGrupo = true;
                }
            });
        });

        const gruposNaoAtribuidos = pool.filter(grupo => {
            return (
                (!professores.some(professor => professor[campoProfessor] && professor[campoProfessor].includes(grupo.id))) &&
                (grupo.grupo_principal_id == grupo.id ||
                    !professores.some(professor => professor[campoProfessor] && professor[campoProfessor].includes(grupo.grupo_principal_id)))
            );
        });

        var gruposOptions = gruposNaoAtribuidos;
        if (contemSubgrupo)
            gruposOptions = gruposNaoAtribuidos.filter(item => item.id != item.grupo_principal_id);
        else if (contemGrupo)
            gruposOptions = gruposNaoAtribuidos.filter(item => item.id == item.grupo_principal_id);

        const options = gruposOptions.map(grupo => ({
            value: grupo.id,
            label: grupo.descricao,
            tipo: grupo.tipo_de_grupo_id,
            grupo_principal_id: grupo.grupo_principal_id
        }));

        return options;
    };

    const gruposOptionsTut = () => {
        const gruposNaoAtribuidos = grupos2.filter(grupo => {
            return !professores.some(professor => professor.tutoria_id && professor.tutoria_id == grupo.id);
        });

        var newObj = {
            id: 0,
            descricao: 'Selecione',
            tipo_de_grupo_id: 0,
            curso_id: 0,
            grupo_principal_id: 0
        }

        gruposNaoAtribuidos.unshift(newObj);

        const options = gruposNaoAtribuidos.map(grupo => ({
            value: grupo.id,
            label: grupo.descricao,
            tipo: grupo.tipo_de_grupo_id,
            grupo_principal_id: grupo.grupo_principal_id
        }));

        return options;
    }

    const locaisOptions = () => {
        var newObj = {
            id: 0,
            nome: 'Selecione',
            tipo_de_grupo_id: 0,
            curso_id: 0,
            grupo_principal_id: 0
        }

        if (locais[0]?.nome != 'Selecione')
            locais.unshift(newObj);

        return locais.map(locais => ({ value: locais.id, label: locais.nome }));
    }

    const gruposOptions = () => grupos.map(grupos => ({ value: grupos.id, label: grupos.descricao }));

    const grupos2Options = () => grupos2.map(grupos2 => ({ value: grupos2.id, label: grupos2.descricao }));

    // const locaisOptions = () => locais.map(locais => ({ value: locais.id, label: locais.nome }))

    // Assinatura barata (string) de quais grupos estão atribuídos, por campo, em todos os
    // professores. Usada como dependência do useMemo abaixo em vez do array `professores`
    // inteiro — assim, editar o campo de UM professor só invalida a pool de opções daquele
    // campo especificamente, e não as opções de EC/CHA/Tutoria/SCP recalculadas do zero a
    // cada tecla, que era o que deixava a seleção lenta.
    const assinaturaPorCampo = (campo) => (professores || []).map(p => (p[campo] || []).join('.')).join('|');

    const assinaturaAce = assinaturaPorCampo('grupo_ace');
    const assinaturaCha = assinaturaPorCampo('grupo_cha') + '~' + assinaturaPorCampo('grupo_cha2');
    const assinaturaMfc = assinaturaPorCampo('grupo_mfc');
    const assinaturaTut = (professores || []).map(p => p.tutoria_id || '').join('|');

    const opcoesGruposFlat = useMemo(() => (grupos ? gruposOptions() : []), [grupos]);
    const opcoesGrupos2Flat = useMemo(() => (grupos2 ? grupos2Options() : []), [grupos2]);
    const opcoesLocaisFlat = useMemo(() => (locais ? locaisOptions() : []), [locais]);
    const opcoesAce = useMemo(() => (grupos ? gruposOptionsPara('ace', 'grupo_ace') : []), [grupos, assinaturaAce]);
    const opcoesCha = useMemo(() => (grupos ? gruposOptionsPara('cha', 'grupo_cha') : []), [grupos, assinaturaCha]);
    const opcoesCha2 = useMemo(() => (grupos ? gruposOptionsPara('cha', 'grupo_cha2') : []), [grupos, assinaturaCha]);
    const opcoesMfc = useMemo(() => (grupos ? gruposOptionsPara('mfc', 'grupo_mfc') : []), [grupos, assinaturaMfc]);
    const opcoesTut = useMemo(() => (grupos2 ? gruposOptionsTut() : []), [grupos2, assinaturaTut]);

    const updateGrupoProfessores = (objeto) => {
        const professoresPrev = professores.slice()
        const professorIndex = professoresPrev.findIndex(professor => professor.id == objeto.row_id)
        professoresPrev[professorIndex] = {
            ...professoresPrev[professorIndex],
            [objeto.campo]: objeto.valor
        }
        setProfessores(professoresPrev)

        // Marca este campo deste professor como efetivamente alterado pelo usuário,
        // para que o backend sincronize horario_aula apenas do que foi de fato editado.
        setAlteracoes(prev => {
            const camposDoProfessor = prev[objeto.row_id] || []
            if (camposDoProfessor.includes(objeto.campo)) return prev
            return {
                ...prev,
                [objeto.row_id]: [...camposDoProfessor, objeto.campo]
            }
        })
    }

    const closeModalCritica = (valor) => {
        setModalCritica(valor)
    }

    const atualizar = async (atualizarHoje) => {
        try {
            setIsLoading(true);
            var novoObj = {
                professores: professores,
                periodo_letivo_id: periodoLetivo,
                atualizar_hoje: atualizarHoje,
                alteracoes: alteracoes
            }
            const response = await axiosApi.put(`professores/grupos-de-professores/1`, novoObj);
            if (response.data.data.tem_critica) {
                setModalCritica(response.data.data.tem_critica)
                setTextoModalCritica(response.data.data.texto)
                setAceFaltando(() => opcoesAce);
                setChaFaltando(() => opcoesCha);
                setTutFaltando(() => opcoesTut);
            }
            setAlteracoes({})
            ativar(201, 'Grupo Atualizado com Sucesso!')
        } catch (error) {
            ativar(400, error?.response?.data[0] ?? error?.response?.data?.error)
        } finally {
            setModal(false);
            setIsLoading(false);
        }
    }

    const regex = /^([A-Za-z]{1})(\d{1,2})|(^$)$/

    const atualizarAula = () => {
        setModalAtualizar(true);
    }

    const verificarAtualizacao = (atualizarHoje) => {
        setModalAtualizar(false);
        atualizar(atualizarHoje);
    }

    const getProfessoresIdFromTable = (acao, objeto) => {
        const { id, semestre_id } = objeto
        if (acao === 'add') {
            setProfessoresIds([...professoresIds, id])
            setSemestreId(semestre_id)
        }
        if (acao === 'remove') {
            const prevProfessoresIds = professoresIds.filter(professorId => professorId !== id)
            setProfessoresIds(prevProfessoresIds)
        }
    }

    // updateGrupoProfessores/getProfessoresIdFromTable são recriadas a cada render (fecham sobre
    // `professores`/`professoresIds` atuais). Isso fazia TODAS as ~26 linhas × ~16 colunas da
    // tabela (muitas delas react-select, componente relativamente pesado) re-renderizarem a cada
    // seleção, já que a referência dessas funções mudava sempre. As duas linhas abaixo dão a elas
    // uma identidade ESTÁVEL (nunca muda), enquanto o `ref` garante que a versão mais recente
    // (com o `professores` atual) é sempre a que de fato executa. Combinado com o React.memo em
    // EditableCell (TableWithVirtualizedRow.jsx), isso permite pular o re-render de linhas/colunas
    // que não foram tocadas pela edição.
    const updateGrupoProfessoresRef = useRef();
    updateGrupoProfessoresRef.current = updateGrupoProfessores;
    const updateGrupoProfessoresEstavel = useCallback((objeto) => updateGrupoProfessoresRef.current(objeto), []);

    const getProfessoresIdFromTableRef = useRef();
    getProfessoresIdFromTableRef.current = getProfessoresIdFromTable;
    const getProfessoresIdFromTableEstavel = useCallback((acao, objeto) => getProfessoresIdFromTableRef.current(acao, objeto), []);

    // Mesma lógica: `disabled` como arrow function inline no array de colunas seria recriada a
    // cada render, o que impediria o React.memo de perceber que nada mudou para essas colunas.
    const tutoriaDisabled = useCallback((row) => {
        if (!professoresTutoria || !Array.isArray(professoresTutoria)) return true;
        return !professoresTutoria.includes(row.id);
    }, [professoresTutoria]);

    const columns = useMemo(() => ([
        {
            Header: 'Nome',
            accessor: 'nome',
            disabled: true,
            style: { width: '250px' },
            id: 'nome_professor',
        },
        {
            Header: 'CPF',
            accessor: 'cpf',
            disabled: true,
            style: { width: '150px' },
        },
        {
            Header: 'Grupo EC',
            accessor: 'grupo_ace',
            id: 'grupo_ace',
            inputType: 'newSelect',
            style: { width: '1050px' },
            selectOptions: opcoesGruposFlat,
            selectOptionsDisponivel: opcoesAce
        },
        {
            Header: 'Local EC',
            accessor: 'local_ace',
            id: 'local_ace',
            inputType: 'select',
            style: { width: '200px' },
            selectOptions: opcoesLocaisFlat,
            selectOptionsDisponivel: opcoesLocaisFlat
        },
        {
            Header: 'Grupo CHA',
            accessor: 'grupo_cha',
            id: 'grupo_cha',
            inputType: 'newSelect',
            style: { width: '1050px' },
            selectOptions: opcoesGruposFlat,
            selectOptionsDisponivel: opcoesCha
        },
        {
            Header: 'Local CHA',
            accessor: 'local_cha',
            id: 'local_cha',
            inputType: 'select',
            selectOptions: opcoesLocaisFlat,
            selectOptionsDisponivel: opcoesLocaisFlat,
            style: { width: '200px' },
        },
        // SAUDE COLETIVA PRÁTICA só existe no currículo do 7º e 8º semestres
        // (semestre.id 8 e 9, respectivamente).
        ...([8, 9].includes(semestre?.id) ? [
            {
                Header: 'Grupo SAUDE COLETIVA PRÁTICA',
                accessor: 'grupo_mfc',
                id: 'grupo_mfc',
                inputType: 'newSelect',
                style: { width: '1050px' },
                selectOptions: opcoesGruposFlat,
                selectOptionsDisponivel: opcoesMfc
            },
            {
                Header: 'Local SCP',
                accessor: 'local_mfc',
                id: 'local_mfc',
                inputType: 'select',
                selectOptions: opcoesLocaisFlat,
                selectOptionsDisponivel: opcoesLocaisFlat,
                style: { width: '200px' },
            },
        ] : []),
        ...(semestre?.id === 8 ? [
            {
                Header: 'Grupo CHA 2',
                accessor: 'grupo_cha2',
                id: 'grupo_cha2',
                inputType: 'newSelect',
                style: { width: '1050px' },
                selectOptions: opcoesGruposFlat,
                selectOptionsDisponivel: opcoesCha2
            },
            {
                Header: 'Local CHA 2',
                accessor: 'local_cha2',
                id: 'local_cha2',
                inputType: 'select',
                selectOptions: opcoesLocaisFlat,
                selectOptionsDisponivel: opcoesLocaisFlat,
                style: { width: '200px' },
            },
        ] : []),
        {
            Header: 'Grupo Tutoria',
            accessor: 'tutoria_id',
            id: 'tutoria_id',
            inputType: 'select',
            selectOptions: opcoesGrupos2Flat,
            selectOptionsDisponivel: opcoesTut,
            style: { width: '200px' },
            disabled: tutoriaDisabled,
        },
        {
            Header: 'Local Tutoria',
            accessor: 'local_tut',
            id: 'local_tut',
            inputType: 'select',
            selectOptions: opcoesLocaisFlat,
            selectOptionsDisponivel: opcoesLocaisFlat,
            style: { width: '200px' },
            disabled: tutoriaDisabled,
        },
    ]), [
        opcoesGruposFlat, opcoesGrupos2Flat, opcoesLocaisFlat,
        opcoesAce, opcoesCha, opcoesCha2, opcoesMfc, opcoesTut,
        semestre?.id, tutoriaDisabled
    ]);

    const criarGruposProfessores = async (objeto) => {
        try {
            const response = await axiosApi.post(`professores/grupos-de-professores/`, objeto)
            ativar(response.status, response.data.sucesso)
        } catch (error) {
            console.log(error)
            ativar(400, 'Já Existe professor com o grupo referido')
        }
    }

    return (
        <Modal isOpen={modalAdicao} size="lg" id="modal-professor-grupo">
            <ModalAtualizarAula isOpen={modalAtualizar} atualizarAula={verificarAtualizacao} fecharModal={() => setModalAtualizar(false)} />
            <ModalAlertGrupos
                isOpen={modalCritica}
                titulo={'Aviso'}
                mensagem={textoModalCritica}
                setIsOpen={closeModalCritica}
                cha={chaFaltando}
                ace={aceFaltando}
                tut={tutFaltando}
            />
            <ModalHeader className="modal-content">
                <p className="m-0 font-weight-bold nome_modal" a> S{semestre.descricao} -  {semestre?.cursos?.abreviatura}</p>
            </ModalHeader >
            <ModalBody>
                <div className='div-de-teste'>
                    <TableWithVirtualizedRow
                        tabelaClassName="tabelaConsulta"
                        updateMyData={updateGrupoProfessoresEstavel}
                        getAlunosIdFromTable={getProfessoresIdFromTableEstavel}
                        alunosIds={professoresIds}
                        isGrupoProfessor={true} //variavel para saber se vem da tela de professor
                        columns={columns}
                        data={professores}
                        selectOptionsDisponivel={opcoesGruposFlat}
                        setFiltro={setFiltro}
                    />
                </div>
                <Button onClick={() => (setModalAdicao(false), setProfessoresIds([]), setAlteracoes({}))} className="float-left btn-transparente mt-2">Fechar</Button>
                <Button onClick={() => atualizarAula()} color="primary" className="float-right mt-2">Salvar</Button>
            </ModalBody>
            <ModalAgruparAlunos
                isOpen={modalAgrupar}
                setIsOpen={setModalAgrupar}
                alunosIds={professoresIds}
                setAlunosIds={setProfessoresIds}
                selectOptions={grupos2Options()}
                setModalAdicao={setModalAdicao}
                criarGruposAlunos={criarGruposProfessores}
                cursoId={cursoId}
                semestreId={semestreId}
            />
        </Modal>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AssociadorDeGruposProfessor)